import type { PayrollRunStatus } from '@kora/types';

/**
 * Visual status chip for a payroll run. Colors mirror the state-machine
 * order: draft → calculating → calculated → approved → paid (future), or
 * → voided (terminal).
 */
export function PayrollRunStatusPill({ status }: { status: PayrollRunStatus }): JSX.Element {
  const map: Record<PayrollRunStatus, string> = {
    draft: 'bg-gray-900 text-gray-300 border-gray-800',
    calculating: 'bg-blue-950 text-blue-300 border-blue-900',
    calculated: 'bg-indigo/10 text-indigo border-indigo/40',
    approved: 'bg-green-950 text-green-400 border-green-900',
    paid: 'bg-emerald/10 text-emerald border-emerald/40',
    voided: 'bg-red-950/50 text-red-400 border-red-900',
  };
  return (
    <span className={`text-xs px-2 py-0.5 rounded border ${map[status]}`}>
      {status}
    </span>
  );
}
